// app/javascript/projects/components/LoadingButton.jsx

import React from 'react';
import { Button } from 'ui'
import {Link} from 'react-router-dom'
import ColorConstants from 'constants/ColorConstants'
import ClipLoader from 'react-spinners/ClipLoader';

class LoadingButton extends React.Component {
  constructor () {
    super();
  }
  render () {
    const width = this.props.width ? this.props.width : 200;

    const style = this.props.centered ?
      {width: width, margin:"0 auto", position:"relative" }
      :
      {width: width, position:"relative" };

    return (
      <div style={style}>
        <div aria-label={this.props.loading ? "Loading" : null} role="status" style={{position:"absolute", top:"0px", left:"100%", width:"100px", padding:5}}>
          <ClipLoader
              color={ColorConstants.ACTIVE_BUTTON_BLUE}
              sizeUnit={"px"}
              size={20}
              loading={this.props.loading}
          />
        </div>
        {this.props.to && (this.props.loading || this.props.disabled ?
          <Button style={{width:width}}
                  variant={this.props.variant}
                  disabled
                  >{this.props.children}</Button> :
          <Link to={this.props.to}
                className={`ui-btn ui-btn--${this.props.variant || 'white'}`}
                style={{width:width}}
                >{this.props.children}</Link>)
        }
        {!this.props.to && !this.props.type &&
            <Button style={{width:width}}
                    variant={this.props.variant}
                    disabled={this.props.loading || this.props.disabled}
                    onClick={this.props.onClick}
                  >{this.props.children}</Button>
        }
        {this.props.type &&
          <Button style={{width:width}}
                  variant={this.props.variant}
                  disabled={this.props.loading || this.props.disabled}
                  type={this.props.type}
                  >{this.props.children}</Button>

        }
      </div>
    );
  }
}

export default LoadingButton;
